import React, { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'

function IntroAnimation({ file, onClose }) {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = useCallback(() => {
    setIsVisible(false)
    onClose()
  }, [onClose])

  useEffect(() => {
    const timer = setTimeout(handleClose, 3000)
    return () => clearTimeout(timer)
  }, [handleClose])

  if (!isVisible) return null

  const isVideo = file?.type?.startsWith('video')
  const url = file ? URL.createObjectURL(file) : ''

  return (
    <div className="intro-animation">
      {isVideo ? (
        <video autoPlay muted playsInline controls className="intro-video">
          <source src={url} type={file.type} />
        </video>
      ) : (
        <img src={url} alt="Intro Animation" className="intro-image" />
      )}
    </div>
  )
}

IntroAnimation.propTypes = {
  file: PropTypes.oneOfType([
    PropTypes.instanceOf(File),
    PropTypes.instanceOf(Blob),
  ]).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default IntroAnimation
